import { render, staticRenderFns } from "./TagAddModal.vue?vue&type=template&id=51f6f618&scoped=true"
import script from "./TagAddModal.vue?vue&type=script&lang=js"
export * from "./TagAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6f618",
  null
  
)

export default component.exports